export default __webpack_public_path__ + "assets/images/d90bf849e5288460e3aa73e6c580de6e.svg";